<template>
	<div class="modal-backdrop" @click="backgroundClicked($event)">
		<div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
			<header class="modal-header" id="modalTitle">
				<slot name="header"></slot>
				<button type="button" class="btn-close" v-on:click="close()" aria-label="Close modal">x</button>
			</header>
			<section class="modal-body" id="modalDescription">
				<slot name="body"></slot>
			</section>
			<footer class="modal-footer">
				<slot name="footer"></slot>
			</footer>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'modal',
		methods: {
			close() {
				this.$emit('close');
			},
			backgroundClicked(event) {
				if (event.target.classList.length > 0 && event.target.classList[0] === 'modal-backdrop') this.$emit('backgroundClicked');
			}
		}
	};
</script>

<style lang="scss" scoped>
	.modal-backdrop {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index:50;
	}

	.modal {
		background: #FFFFFF;
		overflow-x: auto;
		display: flex;
		flex-direction: column;
		min-width:90%;
		border-radius:7px;

		@media only screen and (min-width: 800px){
			min-width:70%;
		}

		@media only screen and (min-width: 1200px){
			min-width:50%;
		}
	}

	.modal-header {
		padding: 23px;
		display: flex;
	}

	.modal-header {
		border-bottom: 1px solid #eeeeee;
		color: #4AAE9B;
		justify-content: space-between;
	}

	.modal-body {
		position: relative;
		padding: 20px 23px;
		text-align:left;
	}

	.btn-close {
		border: none;
		font-size: 20px;
		padding: 20px;
		cursor: pointer;
		font-weight: bold;
		color: #38b7ea;
		background: transparent;

	}

	h1, h2, h3{
		margin:5px 0 0 0;
	}

	.btn-close{
		line-height:23px;
		font-size:33px;
		padding:0;
	}
</style>
